<div class="wheel" #wheel>
  <img src="assets/old-images/wheel.png" alt="wheel" />
</div>
<div class="timer">
  <span>
    @if (wheelService.status() === 'waiting') { 15.00s }
    <!--  -->
    @if (wheelService.rollDate() && (wheelService.status() === 'running' ||
    wheelService.status() === 'results')) {
    {{ wheelService.rollDate()! | countdown | async }}
    }
    <!--  -->
    @if (wheelService.status() === 'rolling') { ROLLING... }
  </span>
</div>
<div class="arrow">
  <svg
    width="43"
    height="40"
    viewBox="0 0 43 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    @if (currentColor() !== 'gold') {
    <ng-container>
      <path
        d="M23.3213 28.0625C22.5455 29.3629 20.662 29.3629 19.8862 28.0625L11.1961 13.4965C10.4008 12.1633 11.3613 10.4718 12.9137 10.4718L30.2938 10.4718C31.8461 10.4718 32.8067 12.1633 32.0113 13.4965L23.3213 28.0625Z"
        [attr.fill]="arrowColorBorder[currentColor()]"
      />
      <path
        d="M23.3213 28.0625C22.5455 29.3629 20.662 29.3629 19.8862 28.0625L11.1961 13.4965C10.4008 12.1633 11.3613 10.4718 12.9137 10.4718L30.2938 10.4718C31.8461 10.4718 32.8067 12.1633 32.0113 13.4965L23.3213 28.0625Z"
        [attr.fill]="arrowColorMain[currentColor()]"
      />
    </ng-container>
    } @if (currentColor() === 'gold') {
    <g filter="url(#filter0_d_88_400)">
      <path
        d="M23.3213 28.0625C22.5455 29.3629 20.662 29.3629 19.8862 28.0625L11.1961 13.4965C10.4008 12.1633 11.3613 10.4718 12.9137 10.4718L30.2938 10.4718C31.8461 10.4718 32.8067 12.1633 32.0113 13.4965L23.3213 28.0625Z"
        [attr.fill]="arrowColorBorder[currentColor()]"
      />
      <path
        d="M23.3213 28.0625C22.5455 29.3629 20.662 29.3629 19.8862 28.0625L11.1961 13.4965C10.4008 12.1633 11.3613 10.4718 12.9137 10.4718L30.2938 10.4718C31.8461 10.4718 32.8067 12.1633 32.0113 13.4965L23.3213 28.0625Z"
        [attr.fill]="arrowColorMain[currentColor()]"
      />
    </g>
    }
    <defs>
      <filter
        id="filter0_d_88_400"
        x="0.910645"
        y="0.471771"
        width="41.3862"
        height="38.5661"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.765021 0 0 0 0 0.391667 0 0 0 0.45 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_88_400"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_88_400"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_88_400"
        x1="35.7051"
        y1="1.00728"
        x2="10.9819"
        y2="20.1858"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF8D24" />
        <stop offset="1" stop-color="#FFC700" />
      </linearGradient>
    </defs>
  </svg>
</div>
